module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-dla-klasy-2-mj-4.061b26f7.png";